import React, { Component } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { Row, Col, Card, Form, Button } from 'react-bootstrap'
import { PulseLoader } from 'react-spinners'

import { getServerUrl } from '../../../functions/getServerUrl'


class RequestPasswordReset extends Component {

  state = {
    userIdentifier: '',
    sendingPassworedResetRequest: false,
    errorMessage: '',
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  sendPasswordResetRequest = () => {
    if (this.state.sendingPassworedResetRequest) {
      return
    }

    if (!this.state.userIdentifier) {
      return this.props.alert.show('Please enter a username or email address.')
    }

    this.setState({ sendingPassworedResetRequest: true })

    axios({
      method: "POST",
      url: `${getServerUrl()}/request-recover-password/`,
      data: { user_identifier: this.state.userIdentifier },
    })
    .then((response) => {
      this.setState({ sendingPassworedResetRequest: false })

      const message = "An email with instructions for resetting your password has been sent to the email address associated with the requested user account."
      const options = {
        position: 'middle',
        timeout: 0,
        type: 'success',
        onClose: () => this.props.routerProps.history.push('/'),
      }

      return this.props.alert.show(message, options)
    })
    .catch(error => {
      this.setState({ sendingPassworedResetRequest: false })

      let errorMessage
      if (error && error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      } else if (error && error.response && error.response.status === 500) {
        errorMessage = "The server is down."
      } else {
        errorMessage = "There was an error processing your request. Please try again."
      }
      this.props.alert.show(errorMessage)
    })
  }

  render() {
    return (
      <div style={{padding: '20px'}}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Card id="ResetPasswordCard" className="animated fadeInDown">
              <Card.Body>

                <span>
                  Enter your username or the email address. Instructions for resetting your password will be sent to the email address associated with your account.
                </span>

                <br/>
                <br/>

                <Form.Control
                  name="userIdentifier"
                  value={this.state.userIdentifier}
                  onChange={this.handleChange}
                  placeholder="Username or email"
                />

                <br/>
                <br/>

                <center>
                  <Button
                    style={{minWidth: '40%'}}
                    onClick={this.sendPasswordResetRequest}
                  >
                    {this.state.sendingPassworedResetRequest ?
                      <PulseLoader
                        css={`display: block; margin: 0 auto;`}
                        color='white'
                      />
                      :
                      'Request password reset'
                    }
                  </Button>
                </center>

                <br/>
                <br/>

                <Link to='/'>
                  Back to login
                </Link>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default RequestPasswordReset
